"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBackToSiteMenuItem = exports.createBackToProjectsMenuItem = exports.createBackToBriefcasesMenuItem = exports.createBackToBriefcaseMenuItem = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var createBackMenuItem = function (path, textKey, itemKey) { return (React.createElement(sok_ui_1.NavigationMenuItem, { exact: true, key: itemKey, to: path, text: (0, translation_1.getLocalization)(textKey), icon: React.createElement(sok_ui_1.Icon, { className: "fa-arrow-left" }) })); };
var createBackToBriefcaseMenuItem = function (briefcaseId, selectedLanguage) {
    return isNaN(briefcaseId)
        ? null
        : createBackMenuItem("/".concat(selectedLanguage, "/briefcase/").concat(briefcaseId), 'leftnavigation/briefcase/backToBriefcases', 'back-to-briefcase');
};
exports.createBackToBriefcaseMenuItem = createBackToBriefcaseMenuItem;
var createBackToBriefcasesMenuItem = function (selectedLanguage) {
    return createBackMenuItem("/".concat(selectedLanguage, "/briefcases"), 'leftnavigation/briefcase/backToSokobid', 'back-to-sokobid');
};
exports.createBackToBriefcasesMenuItem = createBackToBriefcasesMenuItem;
var createBackToProjectsMenuItem = function (selectedLanguage) {
    return createBackMenuItem("/".concat(selectedLanguage, "/projects"), 'leftnavigation/project/backToprojects', 'back-to-projects');
};
exports.createBackToProjectsMenuItem = createBackToProjectsMenuItem;
var createBackToSiteMenuItem = function (projectId, selectedLanguage) {
    return isNaN(projectId)
        ? null
        : createBackMenuItem("/".concat(selectedLanguage, "/projects/").concat(projectId, "/sokosite"), 'leftnavigation/sokosite/backToSite', 'back-to-sokosite');
};
exports.createBackToSiteMenuItem = createBackToSiteMenuItem;
